module.exports = __webpack_public_path__ + "bfdfd3a925160e70b159c2d6253c4713.pdf";